export default "__VITE_ASSET__Bi7UO6ap__"